module.exports = __webpack_public_path__ + "static/media/Photo.b3289ae1.png";